var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nx-tags"},[_c('ul',{staticClass:"tags-box nx-no-scrollbar"},_vm._l((_vm.tagsList),function(item,index){return _c('li',{key:index,staticClass:"tag nx-flex-align-center"},[_c('span',{staticClass:"nx-change-active-color"},[_vm._v("# "+_vm._s(item.name ? item.name : item))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }